
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import { PrivateRoute, PublicRoute } from './PrivateAuth';
import 'bootstrap/dist/css/bootstrap.min.css';
import Login from './Components/Public/Login/Login';
import DashBoard from './Components/Private/Pages/DashBoard/DashBoard';
import Header from './Components/Private/Header/Header';
import Sidebar from './Components/Private/Sidebar/Sidebar';
import Users from './Components/Private/Pages/Users/Users';
import Session from './Components/Private/Pages/Users/Session';
import Payment from './Components/Private/Pages/Payment/Payment';
import Maintenance from './Components/Private/Pages/Maintenance/Maintenance';
import Profile from './Components/Private/Pages/Profile/Profile';
import NotFound from './Components/Public/NotFound/NotFound';
import ActiveSession from './Components/Private/Pages/ActiveSession/ActiveSession';
import UnpaidSessions from './Components/Private/Pages/UnpaidSessions/UnpaidSessions';
import Pricing from './Components/Private/Pages/Pricing/Pricing';
import UserDetail from './Components/Private/Pages/Users/UserDetail';
import WalletTransaction from './Components/Private/Pages/WalletTransaction/WalletTransaction';
import TransactionDetail from './Components/Private/Pages/WalletTransaction/TransactionDetail';
import ChargingStation from './Components/Private/Pages/ChargingStation/ChargingStation';
import CoPartners from './Components/Private/Pages/CoPartners/CoPartners';
import Sessions from './Components/Private/Pages/Sessions/Sessions';
import Notification from './Components/Private/Pages/Notification/Notification';
import Topup from './Components/Private/Pages/Topup/Topup';
import SubscriptionPlan from './Components/Private/Pages/SubscriptionPlan/SubscriptionPlan';
import Benefits from './Components/Private/Pages/Benefits/Benefits';
import Cimb from './Components/Private/Pages/Cimb/Cimb';
import SystemWallet from './Components/Private/Pages/SystemWallet/SystemWallet';
import SerialNo from './Components/Private/Pages/Cimb/SerialNo';
import { isLogIn, isSupport } from './Config/Apis';
import './App.css';
import StationProfile from './Components/Private/Pages/StationProfile/StationProfile';
import Bonus from './Components/Private/Pages/Bonus/Bonus';
import Coupons from './Components/Private/Pages/Coupons/Coupons';
import OTP from './Components/Private/Pages/OTP';
import RevenuePerformance from './Components/Private/Pages/IntelligenceHub/RevenuePerformance';
import CustomerBehavior from './Components/Private/Pages/IntelligenceHub/CustomerBehavior';
import OperationalCharging from './Components/Private/Pages/IntelligenceHub/OperationalCharging';
import AppLayout from './AppLayout';
import Feedback from './Components/Private/Pages/ChargingStation/Feedback';
import Carousel from './Components/Private/Pages/Carousel';
import SessionDiscount from './Components/Private/Pages/SessionDiscount';
import PromoBanner from './Components/Private/Pages/PromoBanner';
import CustomerService from './Components/Private/Pages/CustomerService';
import VehicleInfo from './Components/Private/Pages/VehicleInfo';

export const router = (dataval) =>
  createBrowserRouter([
    {
      path: "/",
      element: <PublicRoute />,
      children: [
        { path: '/login', element: <Login /> },
        { path: '/', element: <Login /> },
      ],
    },
    {
      path: "/",
      element: <AppLayout />,
      children: [
        { path: "/dashboard", element: <DashBoard /> },
        { path: "/users", element: <Users /> },
        { path: "/sessions", element: <Sessions /> },
        { path: "/sessions/active", element: <ActiveSession /> },
        { path: "/sessions/unpaid", element: <UnpaidSessions /> },
        { path: "/transactions", element: <WalletTransaction /> },
        { path: "/transactions/wallet/:id", element: <TransactionDetail /> },
        { path: "/system-wallet", element: <SystemWallet /> },
        { path: "/users/session/:id", element: <Session /> },
        { path: "/users/:id", element: <UserDetail /> },
        { path: "/otp", element: <OTP /> },
        ...(dataval?.isTeam || dataval?.isSupport ?
          [
            { path: "intelligence-hub/revenue-business-performance", element: <RevenuePerformance /> },
            { path: "intelligence-hub/customer-behavior-retention", element: <CustomerBehavior /> },
            { path: "/intelligence-hub/operational-charging-network", element: <OperationalCharging /> },
          ]
          : [
            ...(dataval?.isSupport ? [] : [
              { path: "intelligence-hub/revenue-business-performance", element: <RevenuePerformance /> },
              { path: "intelligence-hub/customer-behavior-retention", element: <CustomerBehavior /> },
              { path: "/intelligence-hub/operational-charging-network", element: <OperationalCharging /> },
              { path: "/payment", element: <Payment /> },
              { path: "/maintenance", element: <Maintenance /> },
              { path: "/profile", element: <Profile /> },
              { path: "/co-partners", element: <CoPartners /> },
              { path: "/charging-station", element: <ChargingStation /> },
              { path: "/pricing", element: <Pricing /> },
              { path: "/notification", element: <Notification /> },
              { path: "/topup", element: <Topup /> },
              { path: "/subscription", element: <SubscriptionPlan /> },
              { path: "/subscription/benefits", element: <Benefits /> },
              { path: "/cimb", element: <Cimb /> },
              { path: "/cimb/code", element: <SerialNo /> },
              { path: "/station-profile", element: <StationProfile /> },
              { path: "/bonus", element: <Bonus /> },
              { path: "/coupons", element: <Coupons /> },
              { path: "/feedback/:id", element: <Feedback /> },
              { path: "/carousel", element: <Carousel /> },
              { path: "/session-discount", element: <SessionDiscount /> },
              { path: "/promo-banner", element: <PromoBanner /> },
              { path: "/customer-service", element: <CustomerService /> },
              { path: "/vehicle-information", element: <VehicleInfo /> },
            ])
          ]),
      ],
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ],
    {
      future: {
        v7_startTransition: true,
      },
    }
  );

